import React, { useEffect, useState, useRef } from 'react';
import ContactForm from '../components/ContactForm.jsx';
import * as Icon from 'react-bootstrap-icons';
import { gsap } from "../../gsap/gsap.min.js";
import { ScrollTrigger } from "../../gsap/ScrollTrigger.min.js";
import axios from 'axios';

gsap.registerPlugin(ScrollTrigger);

function Expertise({ id }) {
	const pageUrl = process.env.REACT_APP_API_PAGE_URL;
	const [page, setPage] = useState(null);
	const [pageTitle, setPageTitle] = useState(null);
	const [pageItems, setPageItems] = useState([]);
	const [activeIndex, setActiveIndex] = useState(0);
	const [isMobile, setIsMobile] = useState(window.innerWidth < 992);
	const [isAccordionOpen, setAccordionOpen] = useState(false);

	const headersRef = useRef([]);
	const accordionRef = useRef(null); 

	useEffect(() => {
		const fetchData = async () => {
			axios.get(`${pageUrl}${id}`).then(res => {
				const response = res.data;
				setPage(response);
			});
		};
		fetchData();
	}, [id]); 

	useEffect(() => {
		if (page != null) {
			setPageTitle(page.title);
			if (page.items != null) {
				setPageItems(page.items);
			}
		}
	}, [page]);

	useEffect(() => {
		const handleResize = () => setIsMobile(window.innerWidth < 992);
		window.addEventListener('resize', handleResize);
		return () => window.removeEventListener('resize', handleResize);
	}, []);

	useEffect(() => {
		if (!isMobile) {
			headersRef.current.forEach((header, index) => {
				const line = header.querySelector('.hover-line');
				const description = header.nextElementSibling;

				gsap.set(line, { scaleX: 0, transformOrigin: "left center" });
				gsap.set(description, { opacity: 0 });

				header.addEventListener("mouseenter", () => {
					gsap.to(line, { scaleX: 0.5, duration: 0.8, ease: "power2.out" });
					gsap.to(description, { opacity: 1, duration: 0.5, ease: "circ.out", delay: 0 });
				});

				header.addEventListener("mouseleave", () => {
					gsap.to(line, { scaleX: 0, duration: 0.8, ease: "power2.out" });
					gsap.to(description, { opacity: 0, duration: 0.5, ease: "circ.out", delay: 0 });
				});
			});
		}
	}, [pageItems, isMobile]);

	const handleClick = (index) => {
		if (isMobile) {
			setActiveIndex(activeIndex === index ? -1 : index); 
		}
	};

	const toggleAccordion = () => {
		if (isAccordionOpen) {
			gsap.to(accordionRef.current, {
				height: 0,
				opacity: 0,
				duration: 0.5,
				ease: 'power2.inOut',
			});
		} else {
			gsap.set(accordionRef.current, { height: 'auto' });
			const height = accordionRef.current.offsetHeight;
			gsap.fromTo(accordionRef.current, {
				height: 0,
				opacity: 0,
			}, {
				height: height + 20,
				opacity: 1,
				duration: 0.5,
				ease: 'power2.inOut',
			});
		}
		setAccordionOpen(!isAccordionOpen);
	};

	return (
		<>
			{pageTitle != null && (
				<div className="bg-dark pt-5 pb-5">
					<div className="container-lg py-5" id="expertise-section">
						<div className="row text-wrapper">
							<div className="col-12">
								<h1 className="fs-2 text-uppercase fw-900 text-white fadeInUp-el">
									{pageTitle}
								</h1>
							</div>
						</div>
					</div>
					{pageItems != null && (
						<div className="container-lg py-5">
							<div className="row text-wrapper">
								<div className="col-12 hover-opacity-others">
									{pageItems.map((item, index) => (
										<div key={index} className={`expertise-el-wrapper ${isMobile && activeIndex === index ? 'open' : ''}`}>
											<h3
												className="expertise-header"
												ref={(el) => (headersRef.current[index] = el)}
												onClick={() => handleClick(index)}
											>
												{item.title}
												<span className="hover-line"></span>
											</h3>
											<p className="mb-lg-0 expertise-body serif" dangerouslySetInnerHTML={{ __html: item.description }}></p>
										</div>
									))}
								</div>
							</div>
						</div>
					)}
					<div className="container-lg py-5">
						<div className='row'>
							<div className="col-12 col-lg-6" id="expertise-section-contact">
								<button
									id="open-expertise-accordion"
									className="btn btn-outline-light rounded-pill fs-8 fw-bold px-4 py-2 fadeInUp-el"
									onClick={toggleAccordion}
								>
									Contact
									{isAccordionOpen ? <Icon.ArrowUpShort className="ms-2" /> : <Icon.ArrowRightShort className="ms-2" />}
								</button>
							</div>
							<div className="col-12 col-lg-6" id="expertise-accordion" style={{ height: 0, overflow: 'hidden' }} ref={accordionRef}>
								<div className='contact-form-container pt-4 pt-lg-0'>
									{/*<h3 className='text-uppercase text-white fs-1 fw-lighter' style={{ letterSpacing: '-1px' }}>Contattaci</h3>*/}
									<ContactForm lightPlaceholder={true} />
								</div>
							</div>
						</div>
					</div> 
				</div>
			)}
		</>
	);
}

export default Expertise;
